import React, { useState } from 'react'
import { useRouteMatch } from 'react-router'
import { Link } from 'react-router-dom'

import { Alert, PageLoader, PortalPage, Stack, withMobile } from 'component-library-next'

import { CustomerDocument, LawyerDocument } from '@app/graphql/types'
import { useIntl } from '@app/intl/Intl'
import { DocumentsList } from '@app/lib/display/DocumentsList/DocumentsList'
import ClientInfo from '@app/modules/ClientsProfile/Components/ClientInfo'
import LawyerNotes from '@app/modules/ClientsProfile/Components/LawyerNotes'
import MobileAvatar from '@app/modules/ClientsProfile/Components/MobileAvatar'
import { MobileNavigation, Tabs } from '@app/modules/ClientsProfile/Components/MobileNavigation'
import { DownloadAllDocumentsButton } from '@app/modules/ClientsProfile/DownloadAllDocumentsButton/DownloadAllDocumentsButton'
import { useClientProfileData } from '@app/modules/ClientsProfile/useClientProfileData'
import { getMessagesPath } from '@app/modules/Messages'
import { getPrintViewPath } from '@app/modules/PrintView'
import { NavBar } from '@app/NavBar'

import './style.scss'

type RouteMatch = { id: string }

export const ClientProfilePage = withMobile(({ mobile }) => {
  const { formatMessage } = useIntl()
  const [activeTab, setActiveTab] = useState<Tabs>(Tabs.Contact)
  const match = useRouteMatch<RouteMatch>()
  const customerId = Number(match?.params.id)
  const { loading, error, data } = useClientProfileData({
    customerId
  })

  if (loading) {
    return <PageLoader loading />
  }

  if (!data || error) {
    return (
      <Alert color={Alert.colors.warning}>
        Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.
      </Alert>
    )
  }

  const { customerInfo, customerDocs, lawyerDocs } = data

  return (
    <NavBar title='Mandanten'>
      <PortalPage hideFooter>
        {mobile && (
          <>
            <MobileAvatar
              src={customerInfo.profilePictureUrl}
              firstName={customerInfo.firstName}
              lastName={customerInfo.lastName}
              productName={customerInfo.productName}
            />

            <MobileNavigation activeTab={activeTab} clickHandler={setActiveTab} />
          </>
        )}

        {(!mobile || activeTab === Tabs.Contact) && <ClientInfo customer={customerInfo} />}

        {(!mobile || activeTab === Tabs.Note) && (
          <LawyerNotes customerId={customerId} note={customerInfo.note} />
        )}
        <Stack>
          {(!mobile || activeTab === Tabs.Documents) && (
            <>
              <div>
                <h4 className='subheading-text'>
                  {formatMessage({ id: 'ClientProfile.Documents.Client' })}
                </h4>
                <DocumentsList documents={customerDocs as CustomerDocument[]} />
                <DownloadAllDocumentsButton documents={customerDocs} />
              </div>
              <div>
                <h4 className='subheading-text'>
                  {formatMessage({ id: 'ClientProfile.Documents.Lawyer' })}
                </h4>
                <DocumentsList documents={lawyerDocs as LawyerDocument[]} />
                <DownloadAllDocumentsButton documents={lawyerDocs} />
              </div>
            </>
          )}
          {(!mobile || activeTab === Tabs.Messages) && (
            <>
              <div>
                <h4 className='subheading-text'>Nachrichtenverlauf</h4>
                <Link to={getMessagesPath(customerInfo.id)}>Kundennachrichten anzeigen</Link>
              </div>
              <div>
                <h4 className='subheading-text'>Druckansicht</h4>
                <Link to={getPrintViewPath(customerInfo.id)}>Druckansicht öffnen</Link>
              </div>
            </>
          )}
        </Stack>
      </PortalPage>
    </NavBar>
  )
})
